import { render, staticRenderFns } from "./billingCenterInnerList.vue?vue&type=template&id=96c798d6&scoped=true&"
import script from "./billingCenterInnerList.vue?vue&type=script&lang=js&"
export * from "./billingCenterInnerList.vue?vue&type=script&lang=js&"
import style0 from "./billingCenterInnerList.vue?vue&type=style&index=0&id=96c798d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c798d6",
  null
  
)

export default component.exports